import { getPathWithQueryParams } from '../helpers/routeHelper'

const { VITE_COMPOSER_FRONTEND_NEXT_API } = import.meta.env

const routes = {
    // Auth
    auth: '/auth',
    login: '/auth/login',
    pluginAuth: '/plugin/success',
    signup: '/auth/signup',
    forgotPassword: '/auth/forgot',
    resetPassword: '/auth/reset',
    // Dashboard
    dashboard: '/dashboard',

    // Messages
    formulasMain: '/messages',
    formulasCatalogWithTabs: (tab) => `/messages/${tab}`,
    // Messages Editor and View
    formulasCreate: '/messages/editor',

    formulaView: (status, formulaId) => `/messages/${status}/${formulaId}`,
    formulaLive: (formulaId) => `/messages/Live/${formulaId}`,
    formulaDraft: (formulaId) => `/messages/Draft/${formulaId}`,

    //Monitoring
    // Live Messages  Live Performance
    monitoringMain: '/monitoring',
    liveMessages: '/monitoring/message-performance',
    liveMessagesLabel: (formulaId, message_type, date_from, date_to) =>
        getPathWithQueryParams(
            `/monitoring/message-performance/message/${formulaId}`,
            {
                message_type,
                date_from,
                date_to,
            },
        ),
    liveMessagesVariant: (
        formulaId,
        labelId,
        variant_type,
        message_type,
        date_from,
        date_to,
    ) =>
        getPathWithQueryParams(
            `/monitoring/message-performance/message/${formulaId}/label/${labelId}`,
            { variant_type, message_type, date_from, date_to },
        ),

    // custom components
    customComponentCreation: '/label-management/create-custom-component',
    viewCustomComponent: (componentId) =>
        `/label-management/custom-component/${componentId}`,
    //Label Management / Personalization
    labelManagement: '/label-management',
    labelDetail: (id) => `/label-management/${id}/details`,

    //Analytics or  Optimized
    insightsMonitoringMain: '/monitoring/insights',
    insightsMonitoringTab: (tab) => `/monitoring/insights/${tab}`,
    optimizedMonitoringMain: '/monitoring/analytics',
    controlledMonitoringMain: '/monitoring/controlled',
    optimizedMonitoringTab: (tab) => `/monitoring/analytics/${tab}`,
    surfaceMonitoring: '/monitoring/surface-performance',
    surfaceDetailMetrics: (surfaceId) =>
        `/monitoring/surface-performance/${surfaceId}`,
    topicManagement: '/topic-management',
    topicManagementCreation: '/topic-management/create',
    topicManagementDetail: (id) => `/topic-management/${id}/details`,
    messageDashboard: '/monitoring/message-dashboard',

    messageSettings: '/message-settings',
    // Audiences
    audience: '/message-settings/audiences',
    audienceCreate: '/message-settings/audiences/create',
    audienceDetail: (audience_id, queryData) =>
        queryData
            ? `/message-settings/audiences/details/${audience_id}?attributes=${queryData}`
            : `/message-settings/audiences/details/${audience_id}`,
    audienceBeta: '/message-settings/audiences/beta',
    audienceCreateBeta: '/message-settings/audiences/beta/create/',
    audienceDetailBeta: (audience_id, queryData) =>
        queryData
            ? `/message-settings/audiences/beta/details/${audience_id}?attributes=${queryData}`
            : `/message-settings/audiences/beta/details/${audience_id}`,

    // Compound-triggers
    compoundTriggers: '/message-settings/triggers',
    compoundTriggerCreate: `/message-settings/triggers/create`,
    compoundTriggerDetail: (id) => `/message-settings/triggers/${id}`,

    // DataSets
    datasetCatalog: '/message-settings/datasets',
    datasetRelationCreate: '/message-settings/datasets/links/create',
    datasetsList: '/message-settings/datasets/catalog',
    datasetsCreate: '/message-settings/datasets/create',
    datasetsView: (datasetId, filters) =>
        filters
            ? `/message-settings/datasets/${datasetId}?${filters}`
            : `/message-settings/datasets/${datasetId}`,

    emailTemplatesCatalog: '/message-settings/email-templates',
    emailTemplateDetail: (templateId) =>
        `/message-settings/email-templates/${templateId}`,
    // Configure to SystemSetup

    // States
    statesMain: '/configure/states',
    stateDetailView: (stateId) => `/configure/states/${stateId}`,

    // System-setup
    eventsMain: '/system-setup/event-managemant',
    eventsFilter: (event_type) =>
        getPathWithQueryParams(`/system-setup/event-managemant`, {
            event_type,
        }),

    rewardFunctionsMain: `${VITE_COMPOSER_FRONTEND_NEXT_API}/system-setup/reward-functions`,

    // Funnel
    funnelMain: '/system-setup/funnel',

    // Attributes
    attributes: '/system-setup/attributes',
    attributeValues: (attribute_id) =>
        `/system-setup/attributes/${attribute_id}/values`,

    //frequency limits
    frequencyLimits: '/system-setup/default-frequency-limits',

    // account
    accountMain: '/system-setup/account-members',
    team: '/system-setup/account-members/team',
    payment: '/system-setup/account-members/payments',
    demo: '/system-setup/account-members/demo',
    testMessageSettings: '/system-setup/account-members/test-message-setting',

    //general
    systemSetupMain: '/system-setup',

    // Integrations
    integrationMain: '/system-setup/integrations',
    integrationEvents: '/system-setup/integrations/events',
    integrationApiKeys: '/system-setup/integrations/api-keys',
    integrationLlmContext: '/system-setup/integrations/llm-context',
    integrationEventsCreate: (eventProviderName) =>
        `/system-setup/integrations/events/create/${eventProviderName}`,
    integrationMessage: '/system-setup/integrations/message',
    integrationCreate: (providerName) =>
        `/system-setup/integrations/create/${providerName}`,
    integrationDetail: (id) => `/system-setup/integrations/detail/${id}`,

    // Languages
    languagesMain: '/system-setup/languages',
    languageCreate: '/system-setup/languages/create',
    languageSettings: '/system-setup/languages/settings',
    languageDetail: (languageId) => `/system-setup/languages/${languageId}`,
    languageEdit: (languageId) => `/system-setup/languages/${languageId}/edit`,

    // snippets
    genAI: '/genai-assistant',

    // Inspiration
    inspiration: '/inspiration-library',

    //Surface
    surface: '/surfaces',
    surfaceCreate: '/surfaces/create',
    surfaceDetails: (id) => `/surfaces/${id}`,
    surfaceDetailsStep: (id, step) => `/surfaces/${id}?current_step=${step}`,
    surfaceView: (id) => `/surfaces/${id}/view`,
    surfaceFormulaDetails: (id, formulaId) =>
        `/surfaces/${id}/formula/${formulaId}`,

    // Surface Templates
    surfaceTemplates: '/surfaces/custom-templates',
    surfaceTemplateCreate: '/surfaces/custom-templates/create',
    surfaceTemplateDetails: (id) => `/surfaces/custom-templates/${id}`,

    // Documentation
    docsLogin: '/reference/intro/authentication',

    // #TODO: includes paths from SampleTable.js after their creation

    messageSequencing: '/sequences',
    messageSequencesCatalogWithTabs: (tab) => `/sequences/${tab}`,

    messageSequencingCreate: '/sequences/create',
    messageSequencingDetail: (id, status = 'Draft') =>
        `/sequences/${status}/${id}`,
    messageSequencingTouchpointFormula: (id, touchpointId, formulaId) =>
        `/sequences/${id}/touchpoint/${touchpointId}/formula/${formulaId}`,

    aampeAdmin: '/aampe-admin',
    aampeAdminCreateCustomer: '/aampe-admin/create-customer',
}

export default routes
